<app-header text='default'></app-header>
<div id="content">
  <div id="readspeaker_button1" class="rs_skip rsbtn rs_preserve" *ngIf="env.readspeaker.enabled">
    <a rel="nofollow" class="rsbtn_play" accesskey="L" i18n-title="@@readSpeakerDescription" title="Listen to this page using ReadSpeaker webReader" [href]="getReadSpeakerURL('content')">
        <span class="rsbtn_left rsimg rspart"><span class="rsbtn_text"><span i18n="@@readSpeakerListen">Listen</span></span></span>
        <span class="rsbtn_right rsimg rsplay rspart"></span>
    </a>
</div>
  <div class="heading" i18n="">Pick your goal</div>
  <div class="description text" i18n="">I want to check my skills so that I can...</div>
  <div class="container">
    <div class="row">
      <div *ngFor="let interest of interests" class="interest col-12 col-xl-6 box shadows gradient" [ngClass]="interest.colour" (click)="selectInterest(interest)">
        <div class="tile d-flex column align-items-center">
          <div class="text" [attr.id]="'goal'+ interest.id">
            <div class="bold">{{ getCategory(interest.category) }}</div>
            {{ interest.text }}
          </div>
          <img src="{{ getPath(interest.resource) }}" onerror="this.remove()">
          
        </div>
      </div>
    </div>
  </div>
</div>
<div class="footer">
  <app-navigate-button text="default" destination=""></app-navigate-button>
</div>